import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStack20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconImageStack20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 3.5h-10a1 1 0 0 0-1 1V5h8A2.5 2.5 0 0 1 16 7.5v5h.5a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1M16 14h.5a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 16.5 2h-10A2.5 2.5 0 0 0 4 4.5V5h-.5A2.5 2.5 0 0 0 1 7.5v7A2.5 2.5 0 0 0 3.5 17h10a2.5 2.5 0 0 0 2.5-2.5zM3.5 6.5h10a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2.441l-.029-.03-5-5-.449-.45-.517.37L2.5 12.22V7.5a1 1 0 0 1 1-1m-1 7.565v.435a1 1 0 0 0 1 1h5.44l-3.521-3.52zM10.75 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStack20);
